export default "__VITE_ASSET__OyA_YTc1__"